import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { X, CheckCircle } from '@phosphor-icons/react'

const HolidayTipsPaymentResult = ({ type, onClose = () => {} }) => {
  const { t } = useTranslation(['holiday-tips'])
  return (
    <div className={`holiday-tips__payment-result payment-${type}`}>
      {type === 'success' ? <CheckCircle size={24} /> : <X size={24} />}
      <span>
        {type === 'success'
          ? t('holiday-tips:result.successMessage')
          : t('holiday-tips:result.errorMessage')}
      </span>
      <button className="holiday-tips__item-button" onClick={onClose}>
        {type === 'success'
          ? t('holiday-tips:result.successButton')
          : t('holiday-tips:result.errorButton')}
      </button>
    </div>
  )
}

HolidayTipsPaymentResult.propTypes = {
  type: PropTypes.oneOf(['success', 'error']).isRequired,
  onClose: PropTypes.func.isRequired,
}

export default HolidayTipsPaymentResult
